import { Package } from "lucide-react";

type ProductImagePlaceholderProps = {
  className?: string;
  iconSize?: number;
  showLabel?: boolean;
};

export const ProductImagePlaceholder = ({
  className = "",
  iconSize = 40,
  showLabel = false,
}: ProductImagePlaceholderProps) => {
  return (
    <div
      className={`absolute inset-0 flex flex-col items-center justify-center bg-[#f3f4f6] text-vg-gray/45 ${className}`}
      data-testid="product-image-placeholder"
      aria-hidden={!showLabel}
    >
      <Package size={iconSize} strokeWidth={1.25} />
      {showLabel && (
        <span className="mt-2 font-mono-acc text-[10px] uppercase tracking-[0.15em] text-vg-gray/60">
          No image
        </span>
      )}
    </div>
  );
};

export default ProductImagePlaceholder;
